import React, { useState } from "react";
import "./Footer.css";

const Footer = () => {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (email) {
      setSubmitted(true);
      setEmail("");
    }
  }; 

  return (
    <footer className="footer">
      <div className="footer-container">

        {/* LEFT */}
        <div className="footer-about">
          {/* <h2>Education & Environment Society</h2> */}
          <img src="images/logo.png" alt="EES Logo" className="footer-logo" />
          {/* <p>
            Empowering communities through education and sustainable development.
          </p> */}

          {/* SOCIAL */}
          <div className="socials">
            <i className="fa-brands fa-facebook-f"></i>
            <i className="fa-brands fa-instagram"></i>
            <i className="fa-brands fa-linkedin-in"></i>
          </div>
        </div>

        {/* LINKS */}
        <div className="footer-links">
          <h4>Quick Links</h4>
          <a href="#home">Home</a>
          <a href="#about-us">About</a>
          <a href="#council">Council</a>
          <a href="#gallery">Gallery</a>
          <a href="#contact">Contact</a>
        </div>

        {/* CONTACT */}
        <div className="footer-contact">
          <h4>Contact</h4>
          <p>264/12 A (Third Floor), Shankar Marg
Mandawali, Delhi 110092</p>
         {/* <p>
  Email: 
  <a href="mailto:eesdelhi@yahoo.com?subject=Enquiry&body=Hello, I want to know more...">
    eesdelhi@yahoo.com
  </a>
</p> */}

<p>
  <i class="fa-solid fa-envelope"></i>
  <a href="mailto:eesdelhi@yahoo.com">eesdelhi@yahoo.com</a>
</p>
        
        </div>

        {/* NEWSLETTER */}
        <div className="footer-newsletter">
          <h4>Subscribe</h4>

          {submitted ? (
            <p className="success">✔ Subscribed successfully!</p>
          ) : (
            <form onSubmit={handleSubmit}>
              <input
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <button type="submit">→</button>
            </form>
          )}
        </div>

      </div>

      {/* BOTTOM */}
      <div className="footer-bottom">
        © {new Date().getFullYear()} Education & Environment Society
      </div>
    </footer>
  );
};

export default Footer;